export const menu = [
  {
    key: 'orders',
    label: 'Orders',
    translationKey: 'app.navigation.main.orders',
    to: '/orders',
    exact: false,
  },
  {
    key: 'invoices',
    label: 'Invoices',
    translationKey: 'app.navigation.main.invoices',
    to: '/invoices',
    exact: false,
  },
  {
    key: 'orderLines',
    label: 'Order lines',
    translationKey: 'app.navigation.main.orderLines',
    to: '/order-lines',
    exact: false,
  },
  {
    key: 'transactions',
    label: 'Transactions',
    translationKey: 'app.navigation.main.transactions',
    to: '/transactions',
    exact: false,
  },
  {
    key: 'pricingRules',
    label: 'Pricing rules',
    translationKey: 'app.navigation.main.pricingRules',
    to: '/pricing-rules',
    exact: false,
  },
  {
    key: 'coupons',
    label: 'Coupons',
    translationKey: 'app.navigation.main.coupons',
    to: '/coupons',
    exact: false,
  },
  {
    key: 'providers',
    label: 'Providers',
    translationKey: 'app.navigation.main.providers',
    to: '/providers',
    exact: false,
  },
  {
    key: 'serviceCosts',
    label: 'Service costs',
    translationKey: 'app.navigation.main.serviceCosts',
    to: '/service-costs',
    exact: false,
  },
];

export const wmsItemsMenu = [
  {
    key: 'attach',
    label: 'Attach',
    translationKey: 'app.navigation.main.attach',
    to: '/attach',
    exact: false,
  },
];

export default menu;
